// Firebase Web SDK bootstrap for "Continue with SocialPulse"
// Shared with every SocialPulse sister site (voltaic-space-843 project).
import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  browserLocalPersistence,
  setPersistence,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const firebaseReady = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

let _app = null;
let _auth = null;

export function getFirebaseAuth() {
  if (!firebaseReady) return null;
  if (!_app) {
    _app = getApps()[0] || initializeApp(firebaseConfig);
  }
  if (!_auth) {
    _auth = getAuth(_app);
    setPersistence(_auth, browserLocalPersistence).catch(() => {});
  }
  return _auth;
}

/** Opens the Google popup and returns the Firebase user + ID token. */
export async function signInWithSocialPulse() {
  const auth = getFirebaseAuth();
  if (!auth) throw new Error("Firebase is not configured on this deployment.");
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  const result = await signInWithPopup(auth, provider);
  const idToken = await result.user.getIdToken(true);
  return { user: result.user, idToken };
}
